import Head from 'next/head';
import React from 'react';
import Styles from './MaoNaRoda25.css';
import SeguroAuto25MaoNaRoda from '@/components/organisms/SeguroAuto25MaoNaRoda';
import MaoNaRoda25Comparativo from '@/components/organisms/MaoNaRoda25Comparativo';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import MaoNaRoda25Condicoes from '@/components/organisms/MaoNaRoda25Condicoes';
import SegurosMaoNaRodaConteudos from '@/components/organisms/SegurosMaoNaRodaConteudos';

function MaoNaRoda25() {
  const faqTitle = 'Saiba mais sobre o Mão na Roda';
  const imgpng = 'assets/mao-na-roda-25/perguntas/img-perguntas.jpg';
  // const imgwebp = 'assets/mao-na-roda-25/perguntas/img-perguntas.webp';
  const imgpngdesk = 'assets/mao-na-roda-25/perguntas/img-perguntas-desk.jpg';
  // const imgwebpdesk = 'assets/mao-na-roda-25/perguntas/img-perguntas-desk.webp';
  const imgalt =
    'Cliente consultando informações sobre seguro veicular e assistência para veículo financiado na Santander Financiamentos';
  const faqs = [
    {
      pergunta: 'Existe alguma carência para o produto?',
      resposta: `Não. A partir do momento em que o produto for contratado, as coberturas já estarão valendo.`,
    },
    {
      pergunta: 'O produto Mão na Roda só pode ser contratado juntamente com o financiamento?',
      resposta: `Sim, não á contratação individual do produto.`,
    },
    {
      pergunta: 'Haverá possibilidade de incremento para esse produto?',
      resposta: `Apenas para alteração de dados pessoais ou cancelamento. Não é possível alterar ou adicionar coberturas.`,
    },
    {
      pergunta: 'Qual a vigência do produto? Poderá ser renovado?',
      resposta: `Vigência de 12 meses sem renovação.`,
    },
    {
      pergunta: 'A emissão da apólice será feita por CPF ou veículo?',
      resposta: `Emissão realizada por veículo + CPF. A cobertura do produto pode ser utilizada apenas e exclusivamente para o veículo informado (carro ou moto). `,
    },
    {
      pergunta: 'Quais são os canais de atendimento?',
      resposta: `WhatsApp: 11 99931-6239<Br />
                Central de atendimento: 0800 201 9500`,
    },
  ];
  return (
    <>
      <Head>
        <title>Mão na Roda: Proteção para Carro e Moto | Santander</title>
        <meta
          name="Description"
          content="Conheça o Mão na Roda, assistência para carro e moto com cobertura para pequenos reparos, pneus, rodas, vidros, faróis e outros itens."
        />
        <meta name="robots" content="index, follow" />
        <meta name="keywords" content="TODO: keywords da LP Mão na Roda" />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/mao-na-roda.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Mão na Roda: Proteção para Carro e Moto | Santander" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/mao-na-roda.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />;
        <meta
          property="og:description"
          content="Conheça o Mão na Roda, assistência para carro e moto com cobertura para pequenos reparos, pneus, rodas, vidros, faróis e outros itens"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/mao-na-roda-25/hero/hero-800.png"
        />
        <meta property="og:image:alt" content="" />
        <meta property="og:image:type" content="image/" />
        <meta property="og:image:width" content="" />
        <meta property="og:image:height" content="" />
        <meta property="og:type" content="" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Mão na Roda: Proteção para Carro e Moto | Santander" />
        <meta
          name="twitter:description"
          content="Conheça o Mão na Roda, assistência para carro e moto com cobertura para pequenos reparos, pneus, rodas, vidros, faróis e outros itens"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/mao-na-roda.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/mao-na-roda-25/hero/hero-800.png"
        />
        <meta property="twitter:image:alt" content="" />
        <meta property="twitter:image:type" content="image/" />
        <meta property="twitter:image:width" content="" />
        <meta property="twitter:image:height" content="" />
      </Head>

      <SeguroAuto25MaoNaRoda />

      <MaoNaRoda25Comparativo />
      <MaoNaRoda25Condicoes />
      <FaqLPs25
        imgpng={imgpng}
        // imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        // imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
      />
      <SegurosMaoNaRodaConteudos />
      <style jsx>{Styles}</style>
    </>
  );
}

export default MaoNaRoda25;
